module.exports = __webpack_public_path__ + "static/media/Texas.c8f23b79.png";